import { useRouter } from 'next/router';

import { STALE_TIME } from '@framework/constants/query';

import usePage from '@hooks/rooms/usePage';
import useRoom from '@hooks/rooms/useRoom';

const useActiveRoom = (enabled = true) => {
    const { query } = useRouter();
    const { isRoomCreationView, isRoomEditView } = usePage();
    const isRoomAdminView = isRoomCreationView || isRoomEditView;
    const roomId = (query.room || query?.room_id) as string | undefined;

    const { data: activeRoomData } = useRoom({
        id: roomId,
        organisationId: query.organisation as string | undefined,
        staleTime: STALE_TIME,
        enabled: !isRoomAdminView && enabled && Boolean(roomId)
    });

    return activeRoomData;
};

export default useActiveRoom;
